export const FETCH_ALL__REQUEST = "TEMPLATE METADATA > FETCH ALL > REQUEST";
export const FETCH_ALL__SUCCESS = "TEMPLATE METADATA > FETCH ALL > SUCCESS";
export const FETCH_ALL__ERROR = "TEMPLATE METADATA > FETCH ALL > ERROR";

export const FETCH_VISIBLE_OVERVIEW__REQUEST =
  "TEMPLATE METADATA > FETCH VISIBLE OVERVIEW > REQUEST";
export const FETCH_VISIBLE_OVERVIEW__SUCCESS =
  "TEMPLATE METADATA > FETCH VISIBLE OVERVIEW > SUCCESS";
export const FETCH_VISIBLE_OVERVIEW__ERROR =
  "TEMPLATE METADATA > FETCH VISIBLE OVERVIEW > ERROR";

export const FETCH_BY_TEMPLATE_ID__REQUEST =
  "TEMPLATE METADATA > FETCH BY TEMPLATE ID > REQUEST";
export const FETCH_BY_TEMPLATE_ID__SUCCESS =
  "TEMPLATE METADATA > FETCH BY TEMPLATE ID > SUCCESS";
export const FETCH_BY_TEMPLATE_ID__ERROR =
  "TEMPLATE METADATA > FETCH BY TEMPLATE ID > ERROR";

export const BULK_FETCH_BY_TEMPLATE_IDS__REQUEST =
  "TEMPLATE METADATA > BULK FETCH BY TEMPLATE IDS > REQUEST";
export const BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS =
  "TEMPLATE METADATA > BULK FETCH BY TEMPLATE IDS > SUCCESS";
export const BULK_FETCH_BY_TEMPLATE_IDS__ERROR =
  "TEMPLATE METADATA > BULK FETCH BY TEMPLATE IDS > ERROR";

export const SET_VISIBLE_OVERVIEW_TEMPLATES =
  "TEMPLATE METADATA > SETTING VISIBLE OVERVIEW TEMPLATES";

export const UPDATE_TEMPLATES_ORDER =
  "TEMPLATE METADATA > UPDATE TEMPLATES ORDER";
